const COOKIE_NAME = "eightarms_consent";

function loadScript(type) {
  const scripts = Array.from(
    document.querySelectorAll(`script[data-consent="${type}"]`),
  );
  scripts.forEach((blockedScript) => {
    const script = document.createElement("script");
    if (blockedScript.hasAttribute("data-src")) {
      script.src = blockedScript.dataset.src;
    } else {
      script.textContent = blockedScript.textContent;
    }
    blockedScript.replaceWith(script);
  });
}

export function getConsent() {
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${COOKIE_NAME}=`));

  if (!match) {
    return {};
  }

  try {
    return JSON.parse(decodeURIComponent(match.split("=")[1]));
  } catch {
    return {};
  }
}

export function setConsent(consent) {
  console.log(consent);

  document.cookie = [
    `${COOKIE_NAME}=${encodeURIComponent(JSON.stringify(consent))}`,
    "Path=/",
    "Max-Age=15552000", // 180 days
    "SameSite=Lax",
    "Secure",
  ].join("; ");

  applyConsent(consent);
}

export function applyConsent(consent) {
  console.log(`applyConsent(${JSON.stringify(consent)})`);
  if (consent.analytics) {
    loadScript("analytics");
  }
}
